import React from 'react';
import Logger from '../../services/logger';

export default function HandleGlobalError() {
  React.useEffect(function onFirstMount() {
    window.onerror = function handleGlobalError(message) {
      Logger.error(message);
      return null;
    };
  }, []);

  return null;
}
